import { ALERT_NOTIFICATION_TAB_PANELS } from '@/alert/utils/define';

export const USE_STATUS_BANNER_FIELD = ['kakaoTalk'];
export const USE_ALERT_NOTIFICATION_USER_TEMPLATE = ['email', 'sms', 'onSite', 'kakaoTalk'];
export const USE_ALERT_NOTIFICATION_SERVER_TYPE = ['email', 'sms', 'kakaoTalk'];
export const USE_ALERT_NOTIFICATION_GRID = ['slack', 'telegram', 'webhook'];
export const USER_TEMPLATE_TOGGLE_TARGETS = ['webhook'];
export const IS_SEND_PER_USER_TYPES = ['webhook'];
export const ALERT_RECEIVE_TYPE = {
  EMAIL: 'email',
  ON_SITE: 'onSite',
  SLACK: 'slack',
  SMS: 'sms',
  TELEGRAM: 'telegram',
  WEBHOOK: 'webhook',
  KAKAO_TALK: 'kakaoTalk',
} as const;

export const writeContent = {
  title: '',
  content: '',
  fixedContent: '',
};

export const notificationList = ALERT_NOTIFICATION_TAB_PANELS.map((item) => item.value);
